/* Shopify bridge. Normal product POST keeps the platform's validation, errors,
 * localized cart redirect and header count. No local/session storage. */
(() => {
  'use strict';
  const NB = window.NB;
  const splitValue = value => {
    const [color, material] = String(value || '').split(/\s*[・·]\s*/);
    return {color: color.trim(), material: material?.trim() || ''};
  };
  function detectOptions(data) {
    const find = pattern => data.options.findIndex(name => pattern.test(name));
    const color = find(/カラー|colou?r/i);
    return {
      color: color >= 0 ? color : data.optionPositions?.color ?? -1,
      count: (() => {
        const index = find(/名前の数|name count|number of names/i);
        return index >= 0 ? index : data.optionPositions?.count ?? -1;
      })(),
      material: find(/素材|material/i),
      message: find(/メッセージ|message/i)
    };
  }
  const colorKey = (value, mapping = {}) => {
    value = splitValue(value).color;
    const normalized = String(value).toLowerCase().replace(/[\s_-]/g, '').replace(/colour/g, 'color');
    return Object.keys(NB.config.colors).find(key => value === mapping[key])
      || ({gold:'gold', goldcolor:'gold', silver:'silver', silvercolor:'silver', rose:'rose', rosegold:'rose', rosegoldcolor:'rose', 'ゴールドカラー':'gold', 'シルバーカラー':'silver', 'ローズゴールドカラー':'rose'})[normalized];
  };
  // Pure resolver also used by the offline contract tests.
  function resolve(data, design, extras = {}) {
    const {color: colorIndex, count: countIndex} = detectOptions(data);
    return data.variants.find(v => v.options.every((value, i) => {
      if (i === colorIndex) return colorKey(value, data.colorValues) === design.color && (extras[i] === undefined || splitValue(value).material === extras[i]);
      if (i === countIndex) return parseInt(value, 10) === design.count;
      return extras[i] === undefined || value === extras[i];
    })) || null;
  }
  NB.shopify = {
    resolve,
    splitValue,
    detectOptions,
    colorKey,
    setup(root) {
      const data = JSON.parse(root.querySelector('[data-product-variants]').textContent);
      const form = root.querySelector('form');
      form.querySelectorAll('[name="form_type"], [name="utf8"]').forEach(input => { input.disabled = true; });
      form.noValidate = true; // Japanese validation in JS; native attributes remain for no-JS.
      const initial = data.variants.find(v => v.id === data.selected) || data.variants[0];
      const {color: colorIndex, count: countIndex} = detectOptions(data);
      const {message: messageIndex} = detectOptions(data);
      const extras = {};
      const messageRoot = form.querySelector('[data-message-print]');
      const messageCheck = messageRoot?.querySelector('[data-message-check]');
      if (messageIndex >= 0) {
        const values = data.optionValues?.[messageIndex] || [...new Set(data.variants.map(v => v.options[messageIndex]))];
        extras[messageIndex] = initial?.options[messageIndex] || values[0];
        if (messageCheck) {
          messageCheck.checked = extras[messageIndex] !== values[0];
          messageRoot.querySelector('[data-message-panel]').hidden = !messageCheck.checked;
          messageRoot.querySelectorAll('[data-message-field]').forEach(field => { field.disabled = !messageCheck.checked; });
          messageRoot.querySelector('[data-message-text]').required = messageCheck.checked;
          messageCheck.addEventListener('change', () => {
            extras[messageIndex] = messageCheck.checked ? values[1] : values[0];
            NB.approval.invalidate();
            NB.configurator?.refresh();
          });
        }
      }
      const merged = colorIndex >= 0 && /素材|material/i.test(data.options[colorIndex]);
      const extraRoot = root.querySelector('[data-extra-options]');
      extraRoot.replaceChildren();
      data.options.forEach((option, i) => {
        if (i === countIndex || i === messageIndex || (i === colorIndex && !merged)) return;
        const optionValue = value => i === colorIndex ? splitValue(value).material : value;
        extras[i] = optionValue(initial?.options[i]);
        const label = document.createElement('label');
        label.className = 'quantity-label';
        label.append((i === colorIndex ? root.dataset.materialLabel || option : option) + ' ');
        const select = document.createElement('select');
        select.dataset.optionIndex = String(i);
        [...new Set(data.variants.map(v => optionValue(v.options[i])))].forEach(value => select.add(new Option(value, value)));
        select.value = extras[i];
        label.append(select);
        extraRoot.append(label);
        select.addEventListener('change', () => {
          extras[i] = select.value;
          NB.approval.invalidate();
          NB.configurator?.refresh();
        });
      });
      const hiddenId = form.querySelector('[data-variant-id]');
      hiddenId.disabled = false;
      form.querySelector('[data-variant-fallback]').disabled = true;
      form.querySelector('[data-font-fallback]').disabled = true;
      form.querySelector('[data-font-property]').disabled = false;
      root.classList.add('preview-ready');
      let variant = initial;
      let currentDesign = null;
      const api = {
        initialState: {
          color: colorIndex >= 0 ? colorKey(initial?.options[colorIndex], data.colorValues) || 'gold' : 'gold',
          count: countIndex >= 0 ? parseInt(initial?.options[countIndex], 10) || 1 : 1
        },
        allowsColor(key) { return colorIndex < 0 || data.variants.some(v => colorKey(v.options[colorIndex], data.colorValues) === key); },
        allowsCount(count) { return countIndex < 0 || data.variants.some(v => parseInt(v.options[countIndex], 10) === count); },
        sync(design) {
          currentDesign = design;
          variant = resolve(data, design, extras);
          hiddenId.value = variant?.id || '';
          hiddenId.disabled = !variant;
          const available = Boolean(variant?.available);
          root.querySelector('[data-review-names]').disabled = !available;
          root.querySelector('[data-variant-status]').textContent = available ? '' : variant ? window.CariamText("copy.text_289", '売り切れです。') : window.CariamText("copy.text_290", 'この組み合わせはありません。');
          const price = variant?.money || '—';
          root.querySelectorAll('[data-product-price],[data-config-price],[data-selection-price],[data-confirm-price]').forEach(n => { n.textContent = price; });
          form.querySelector('[data-font-property]').value = NB.util.fontById(design.font).orderLabel;
          form.querySelector('[data-font-id-property]').value = design.font + '-' + NB.util.fontById(design.font).family;
          const colorProperty = form.querySelector('[data-color-property]');
          colorProperty.disabled = true;
          colorProperty.value = NB.config.colors[design.color].orderLabel;
          // Recompute against selected color/extras; keep impossible counts visible,
          // disabled, without silently changing names or reducing their count.
          root.querySelectorAll('[data-count]').forEach(input => {
            input.disabled = !api.allowsCount(Number(input.value));
          });
          root.querySelectorAll('[data-color]').forEach(input => { input.disabled = !api.allowsColor(input.dataset.color); });
        },
        money() { return variant?.money || '—'; },
        submit(approved) {
          NB.approval.assert(approved);
          if (!currentDesign || NB.util.signature(currentDesign) !== NB.util.signature(approved)) throw new Error(window.CariamText("copy.text_252", 'デザインが変わりました。もう一度確認してください。'));
          if (!variant?.available) throw new Error(window.CariamText("copy.text_291", 'この商品は現在購入できません。'));
          if (!form.reportValidity()) throw new Error(window.CariamText("copy.text_292", '入力内容を確認してください。'));
          api.sync(approved);
          NB.messagePrint?.prepare(form);
          NB.approval.consume(approved);
          if (root.dataset.harness === 'true') {
            const detail = Object.fromEntries(new FormData(form));
            root.dispatchEvent(new CustomEvent('nb:harness-submit', {detail, bubbles:true}));
            return;
          }
          HTMLFormElement.prototype.submit.call(form);
        }
      };
      form.querySelector('[name="quantity"]').addEventListener('input', () => NB.approval.invalidate());
      NB.shopify.current = api;
      // Source confirmation retains its one-use approval contract.
      NB.cart = { add(approved) { api.submit(approved); } };
      return api;
    }
  };
})();
